import React from 'react'
import fea2 from '../assets/fea2.webp'
import fea1 from '../assets/fea1.webp'
import author1 from '../assets/author1.webp'
import { AiOutlineShareAlt } from 'react-icons/ai'
export default function BlogCard() {
  return (<div className='grid  grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 justify-center xl:px-[9vw]   items-center '>
    <div className='m-4  pb-4 ' >
      <img src={fea2} alt="" className='  ' />
      <p className='my-2 font-sans text-green-700 m-4' >30 MINUTES - 25 COMMENTS</p>
      <p className='text-blue-900 border-b-2 m-4 pb-4' >Dental Care for Child is very important</p>
      <div className='flex gap-5 justify-between mx-4' >
        <div className='flex gap-5 ' ><img src={author1} className='inline-block ' alt="" />
          <span>
            Morgon Dawson
            <br />
            20 April, 2021
          </span></div>
        <AiOutlineShareAlt className='justify-self-end bg-green-700 rounded-full m-2 h-8 w-8 p-2 ' />
      </div>
    </div>
    <div className='m-4  pb-4' >
      <img src={fea1} alt="" />
      <p className='my-2 font-sans text-green-700 m-4' >30 MINUTES - 25 COMMENTS</p>
      <p className='text-blue-900 border-b-2 m-4 pb-4' >Dental Care for Child is very important</p>
      <div className='flex gap-5 justify-between mx-4' >
        <div className='flex gap-5 ' ><img src={author1} className='inline-block ' alt="" />
          <span>
            Morgon Dawson
            <br />
            20 April, 2021
          </span></div>
        <AiOutlineShareAlt className='justify-self-end bg-green-700 rounded-full m-2 h-8 w-8 p-2 ' />
      </div>
    </div>
    <div className='m-4  pb-4' >
      <img src={fea2} alt="" />
      <p className='my-2 font-sans text-green-700 m-4' >30 MINUTES - 25 COMMENTS</p>
      <p className='text-blue-900 border-b-2 m-4 pb-4' >Dental Care for Child is very important</p>
      <div className='flex gap-5 justify-between mx-4' >
        <div className='flex gap-5 ' ><img src={author1} className='inline-block ' alt="" />
          <span>
            Morgon Dawson
            <br />
            20 April, 2021
          </span></div>
        <AiOutlineShareAlt className='justify-self-end bg-green-700 rounded-full m-2 h-8 w-8 p-2 ' />
      </div>
    </div>
  </div>
  )
}
